import { setAxiosAuth } from "../../http/axios";
import {
  AuthProvider as AuthProviderBase,
  type Session,
  type User,
} from "@belray-ventec/platform-session";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const onSession = (session: { session: Session; user: User }) => {
    setAxiosAuth({
      authToken: session.session.authToken,
    });
  };
  return (
    <AuthProviderBase platform="tribolab" onSession={onSession}>
      {children}
    </AuthProviderBase>
  );
};
